class Blog {
	constructor(request) {
		this.request = request
		this.endpoint = 'blog'
	}

    GetBlogs(type) {
        return this.request.requestData(
            `https://cdn.ngnw.ph/lists/${this.endpoint}/${type}.json`
        )
    }

    GetBlog(url) {
        return this.request.requestData(
            `https://cdn.ngnw.ph/details/${this.endpoint}/${url}.json`
        )
    }

    SearchText(text) {
        const body = {
            "searchtext": text
        }

        return this.request.send(
			`search/recipe/`,
			'POST',
			body
		)
    }
}

export default Blog;